/**
 * cross-sell-attribution.js  (loads on product pages only)
 *
 * Closes the loop for cross-sell attribution beyond the in-cart "Add" button:
 * when a shopper CLICKS a "Complete the look" recommendation in the cart, the card
 * link carries ?added_from=cross-sell. This script remembers that (per product, for
 * the session) and injects a hidden line-item property properties[_added_from]=Cross-sell
 * into the product's add-to-cart form. So buying the clicked product from its own page
 * still stamps the line -> Shopify Flow tags the order "cross-sell".
 * (The looser "cross-sell-influenced" tag is driven separately by the cart attribute.)
 */
(function () {
  function currentHandle() {
    var m = location.pathname.match(/\/products\/([^/?#]+)/);
    return m ? m[1] : null;
  }
  var KEY = 'col_crosssell_handles';
  function getSet() {
    try { return new Set(JSON.parse(sessionStorage.getItem(KEY) || '[]')); } catch (e) { return new Set(); }
  }
  function saveSet(s) {
    try { sessionStorage.setItem(KEY, JSON.stringify(Array.from(s))); } catch (e) {}
  }

  var handle = currentHandle();
  if (!handle) return;

  var params = new URLSearchParams(location.search);
  var set = getSet();
  if (params.get('added_from') === 'cross-sell') { set.add(handle); saveSet(set); }
  if (!set.has(handle)) return; // this product was not reached via a cross-sell click

  function injectInto(form) {
    if (!form || form.querySelector('input[data-cross-sell-prop]')) return;
    var action = (form.getAttribute('action') || '') + '';
    var isAdd = /\/cart\/add/.test(action) || !!form.querySelector('[name="id"]');
    if (!isAdd) return;
    var input = document.createElement('input');
    input.type = 'hidden';
    input.name = 'properties[_added_from]';
    input.value = 'Cross-sell';
    input.setAttribute('data-cross-sell-prop', '');
    form.appendChild(input);
  }
  function scan() {
    document
      .querySelectorAll('form[action*="/cart/add"], product-form-component form, form[is="product-form"]')
      .forEach(injectInto);
  }
  if (document.readyState !== 'loading') scan();
  else document.addEventListener('DOMContentLoaded', scan);
  // Horizon can render the product form after initial parse; catch late forms briefly.
  var mo = new MutationObserver(scan);
  mo.observe(document.documentElement, { childList: true, subtree: true });
  setTimeout(function () { mo.disconnect(); }, 8000);
})();
